import { Badge, Tag } from "antd"
import { defaultFormat } from "../../../utils/date"
import { notifications } from "../../../notifications"
import { CopyOutlined } from "@ant-design/icons"
import JsonViewerModal from "../../../components/base/jsonViewerModal"
import Styles from "./styles.module.css"
import React from "react"
import {
  getAggregatorGameStatusDisplayValue,
  getGameStatusColor,
  getNativeGameStatusDisplayValue,
} from "../helpers"


export const analyticsColumnsBuffPlay = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (id: string) => {
      return (
        <div
          onClick={() => {
            navigator.clipboard.writeText(id)
            notifications.success("Copied id:" + id)
          }}
          style={{
            background: "#A3A3A3",
            width: 24,
            height: 24,
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          <CopyOutlined
            style={{ color: "white", display: "flex", transform: "translate(5px, 2px)" }}
          />
        </div>
      )
    },
  },
  {
    title: "Account Id",
    dataIndex: "accountId",
    key: "accountId",
  },
  {
    title: "Event name",
    dataIndex: "eventName",
    key: "eventName",
  },
  {
    title: (
      <>
        Product type <br />  Event timestamp
      </>
    ),
    dataIndex: "eventTimestamp",
    key: "eventTimestamp",
    render: (el: Date, record) => el && (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        <div>{record.productType || "No Product type"}</div>
        <Tag color="green">{record.eventTimestamp ? defaultFormat(record.eventTimestamp) : "No Event timestamp"}</Tag>
      </div>
    ),
  },
  {
    title: "Fingerprint",
    dataIndex: "fingerprint",
    key: "fingerprint",
  },
  {
    title: "isSyncedToS3",
    dataIndex: "isSyncedToS3",
    key: "isSyncedToS3",
    render: (e: boolean) => String(e),
  },
  {
    title: "Payload",
    dataIndex: "payload",
    key: "payload",
    render: (data: any) => data ? <JsonViewerModal data={data} title="Show Payload" /> : "No data",
  },
  {
    title: (
      <>
        Created At <br />  Updated At
      </>
    ),
    dataIndex: "createdAt",
    key: "createdAt&updatedAt",
    render: (el: Date, record: any) => el && (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        <Tag color="green">{record.createdAt ? defaultFormat(record.createdAt) : "No Created At Date"}</Tag>
        <Tag color="blue">{record.updatedAt ? defaultFormat(record.updatedAt) : "No Updated At Date"}</Tag>
      </div>
    ),
  },
]

export const accountGamesColumnsBuffPlay = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (id: string) => {
      return (
        <div
          onClick={() => {
            navigator.clipboard.writeText(id)
            notifications.success("Copied id:" + id)
          }}
          style={{
            background: "#A3A3A3",
            width: 24,
            height: 24,
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          <CopyOutlined
            style={{ color: "white", display: "flex", transform: "translate(5px, 2px)" }}
          />
        </div>
      )
    },
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (name: string, item) => {
      const isLive = item.isInstallable

      return (
        <Badge
          count={isLive ? "LIVE" : "PAUSED"}
          offset={[8, -8]}
          style={{
            backgroundColor: isLive ? "#d9f7be" : "#bfbfbf",
            color: isLive ? "green" : "white",
            border: `1px solid ${isLive ? "#b7eb8f" : "#bfbfbf"}`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: 10,
            height: 16,
            padding: "0 6px",
            borderRadius: 8,
          }}
        >
          <span style={{ paddingRight: 4 }}>{name}</span>
        </Badge>
      )
    },
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
  },
  {
    title: "Completed Tasks",
    dataIndex: "completedTasks",
    key: "completedTasks",
    render: (_, data) => {
      const completedTasksCount = data.tasks.filter(task => task.completed || ["CLAIMED", "NOT_CLAIMED"].includes(task.status)).length

      return (
        <div className={Styles.tasks}>
          {`${completedTasksCount}/${data.tasks.length}`}
        </div>
      )
    },
  },
]

export const securityLogsColumnsBuffPlay = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (id: string) => {
      return (
        <div
          onClick={() => {
            navigator.clipboard.writeText(id)
            notifications.success("Copied id:" + id)
          }}
          style={{
            background: "#A3A3A3",
            width: 24,
            height: 24,
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          <CopyOutlined
            style={{ color: "white", display: "flex", transform: "translate(5px, 2px)" }}
          />
        </div>
      )
    },
  },
  {
    title: "Account Id",
    dataIndex: "accountId",
    key: "accountId",
  },
  {
    title: "URL",
    dataIndex: "url",
    key: "url",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
  {
    title: "Blocked",
    dataIndex: "isBlocked",
    key: "isBlocked",
    render: (el: boolean) => (el ? "Yes" : "No"),
  },
  {
    title: "Block Reason",
    dataIndex: "blockReason",
    key: "blockReason",
    render: (el: string | null) => <span style={{ textTransform: "capitalize" }}>{el?.split("_").join(" ").toLowerCase()}</span>,
  },
  {
    title: "IP",
    dataIndex: "ip",
    key: "ip",
    render: (_data, record) => (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        <div>{record.ip ? record.ip : "Unknown IP"}</div>
        {record.ipData ? <JsonViewerModal data={record.ipData} title="IP Data" /> : "No IP Data"}
        {record.recaptcha ? <JsonViewerModal data={record.recaptcha} title="Recaptcha info" variant="long" /> : "No recaptcha info"}
        {record.playIntegrity ? <JsonViewerModal data={record.playIntegrity} title="Play integrity" /> : <div>No play integrity</div>}
        {record.fingerprintDetail ? (
          <JsonViewerModal data={record.fingerprintDetail} title="fingerprint.com" />
        ) : (
          <div>No fingerprint.com data</div>
        )}
      </div>
    ),
  },
  {
    title: "Fingerprint",
    dataIndex: "fingerprint",
    key: "fingerprint",
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (el: Date) => el && <Tag color="green">{defaultFormat(el)}</Tag>,
  },
  {
    title: "Advertising Id",
    dataIndex: "advertisingId",
    key: "advertisingId",
  },
]

export const accountNativeGameBuffPlayColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Reward (USD)",
    dataIndex: "rewardUsd",
    key: "rewardUsd",
    render: (value: number | null | undefined) => value != null ? `$${value}` : "-",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (value, row) => {
      // Unified shape: aggregator-origin tasks carry a string `status`; native tasks don't.
      const displayValue = value
        ? getAggregatorGameStatusDisplayValue(value)
        : getNativeGameStatusDisplayValue(row)

      const color = getGameStatusColor(displayValue)

      return (
        <div className={Styles.actions}>
          <Tag color={color}>{displayValue}</Tag>
        </div>
      )
    },
  },
]
